import { render, staticRenderFns } from "./POStockSlipTransaction.vue?vue&type=template&id=350deabc&scoped=true"
import script from "./POStockSlipTransaction.vue?vue&type=script&lang=js"
export * from "./POStockSlipTransaction.vue?vue&type=script&lang=js"
import style0 from "./POStockSlipTransaction.vue?vue&type=style&index=0&id=350deabc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350deabc",
  null
  
)

export default component.exports